import api from "../axios";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

const getUserAccountId = () => {
  return JSON.parse(localStorage.getItem("user"))?.account?.id;
};

// Fetch user profile
export async function getUserProfile() {
  const userAccountId = getUserAccountId();
  const response = await api.get(`/users/${userAccountId}/profile/`);
  return response.data;
}

// Update user profile
export async function updateUserProfile(data) {
  const userAccountId = getUserAccountId();
  const response = await api.put(`/users/${userAccountId}/profile/`, data);
  return response.data;
}
